import {
  SET_RESSOURCEN_STATI,
  SET_RESSOURCEN_BUCHUNGSTYPEN,
  SET_RESSOURCEN_RAEUME,
  SET_RESSOURCEN_GEBAEUDE,
  SET_RESSOURCEN_KONFLIKT_STATI,
  SET_RESSOURCEN_SPERRTERMINE,
  SET_RESSOURCEN_PERIODIZITAET,
  SET_RESSOURCEN_STANDORTE,
  SET_RESSOURCEN_EIGENTUMSVERHAELTNISSE,
  SET_RESSOURCEN_RAUMGRUPPEN, SET_RESSOURCEN_WOCHENTAGE,
} from "./mutations.type";

import { LADE_AUSWAHLWERTE_RESSOURCEN } from "./actions.type";

import Api from "../../api/Api";
import AppApi from "@/api/AppApi";

export default {
  namespaced: true,
  state: {
    ressourcenstati: [],
    ressourcenbuchungstypen: [],
    raeume: [],
    gebaeude: [],
    konfliktstati: [],
    sperrtermine: [],
    periodizitaeten: [],
    standorte: [],
    eigentumsverhaeltnisse: [],
    raumgruppen: [],
    wochentage: [],
  },
  mutations: {
    [SET_RESSOURCEN_STATI](state, val) {
      state.ressourcenstati = val;
    },
    [SET_RESSOURCEN_BUCHUNGSTYPEN](state, val) {
      state.ressourcenbuchungstypen = val;
    },
    [SET_RESSOURCEN_RAEUME](state, val) {
      state.raeume = val;
    },
    [SET_RESSOURCEN_GEBAEUDE](state, val) {
      state.gebaeude = val;
    },
    [SET_RESSOURCEN_KONFLIKT_STATI](state, val) {
      state.konfliktstati = val;
    },
    [SET_RESSOURCEN_SPERRTERMINE](state, val) {
      state.sperrtermine = val;
    },
    [SET_RESSOURCEN_PERIODIZITAET](state, val) {
      state.periodizitaeten = val;
    },
    [SET_RESSOURCEN_STANDORTE](state, val) {
      state.standorte = val;
    },
    [SET_RESSOURCEN_EIGENTUMSVERHAELTNISSE](state, val) {
      state.eigentumsverhaeltnisse = val;
    },
    [SET_RESSOURCEN_RAUMGRUPPEN](state, val) {
      state.raumgruppen = val;
    },
    [SET_RESSOURCEN_WOCHENTAGE](state, val) {
      state.wochentage = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_RESSOURCEN](context) {
      const [mainRes, appRes] = await Promise.allSettled([
        Api.get("ressourcen/auswahlwerte/"),
        AppApi.get("auswahlwerte/ressourcen/"),
      ]);

      if (mainRes.status === "fulfilled") {
        const data = mainRes.value.data || {};
        context.commit(SET_RESSOURCEN_STATI, data.ressourcenstati || []);
        context.commit(
          SET_RESSOURCEN_BUCHUNGSTYPEN,
          data.ressourcenbuchungstypen || []
        );
        context.commit(SET_RESSOURCEN_RAEUME, data.raeume || []);
        context.commit(SET_RESSOURCEN_GEBAEUDE, data.gebaeude || []);
        context.commit(SET_RESSOURCEN_KONFLIKT_STATI, data.konfliktstati || []);
        context.commit(SET_RESSOURCEN_SPERRTERMINE, data.sperrtermine || []);
        context.commit(SET_RESSOURCEN_PERIODIZITAET, data.periodizitaeten || []);
        context.commit(SET_RESSOURCEN_STANDORTE, data.standorte || []);
        context.commit(
          SET_RESSOURCEN_EIGENTUMSVERHAELTNISSE,
          data.eigentumsverhaeltnisse || []
        );
        context.commit(SET_RESSOURCEN_RAUMGRUPPEN, data.raumgruppen || []);
      }

      if (appRes.status === "fulfilled") {
        const appData = appRes.value.data || {};
        context.commit(SET_RESSOURCEN_WOCHENTAGE, appData.wochentage || []);
      }
    },
  },
};
